import React, { useContext } from 'react';

import { Space, Typography } from 'antd';
import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { CardSectionTitle } from '../../common/Styles';
import { getTranslatedString } from 'helpers/i18n';

const { Link } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.name'
    ),
    dataIndex: 'name',
    key: 'name',
    render(value) {
      return <Link href="#">{value}</Link>;
    },
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.flagType'
    ),
    dataIndex: 'flagType',
    key: 'flagType',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.description'
    ),
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.flaggedContent'
    ),
    dataIndex: 'flaggedContent',
    key: 'flaggedContent',
  },
];

const FLAGGED_PRIOR_RESIDENTS_COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.name'
    ),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.property'
    ),
    dataIndex: 'property',
    key: 'property',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.unit'
    ),
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.flags.leaseEndDate'
    ),
    dataIndex: 'leaseEndDate',
    key: 'leaseEndDate',
  },
];

const DUMMY_DATA = [
  {
    key: 1,
    name: 'Geraldine Blanchard',
    flagType: 'Flagged prior resident',
    description: '2 hits',
    flaggedContent: '-',
    flaggedPriorResidents: [
      {
        name: 'Gerri Blanchard',
        property: 'Gardenview Terrace',
        unit: '331',
        leaseEndDate: '2008-04-31',
      },
      {
        name: 'Geraldine Blanchardy',
        property: '38 Salsbury Court',
        unit: '1113',
        leaseEndDate: '2012-07-31',
      },
    ],
  },
];

const Flags = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Space direction="vertical" size="middle">
      <CardSectionTitle>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.flags'
        )}
      </CardSectionTitle>
      <Table
        dataSource={DUMMY_DATA}
        columns={COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={false}
        rowExpandable={(record) => record.flaggedPriorResidents}
        expandedRowRender={(record) => (
          <Table
            dataSource={record.flaggedPriorResidents}
            columns={FLAGGED_PRIOR_RESIDENTS_COLUMNS}
            hideActionAndSearch
            size={isMobile ? 'middle' : 'small'}
            scroll={{
              x: isMobile,
            }}
            pagination={false}
          />
        )}
      />
    </Space>
  );
};

export default Flags;
